import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import userCenter from "@/views/userCenter/userCenter"
import userInfo from "@/views/userCenter/details/userInfo"

import privacy from "@/views/details/privacy";

import userAgreement from "@/views/details/userAgreement";
Vue.use(Router);

export default new Router({
  //mode:'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'goPayment',
    //   component: goPayment,
    //   meta: {
    //     tx:1
    //   }
    // },
    {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/login',
      name: 'login',
      component:  () => import("../views/login/login.vue"),
    },
    {
      path: '/forgetPwd',
      name: 'forgetPwd',
      component:  () => import("../views/login/forgetPwd.vue"),
    },
    {
      path: '/register',
      name: 'register',
      component:  () => import("../views/login/register.vue"),
    },
    {
      path: '/tbList',
      name: 'tbList',
      component:  () => import("../views/tbList.vue"),
    },
    {
      path: '/toubiao',
      name: 'toubiao',
      component:  () => import("../views/index/toubiao.vue"),
    },
    {
      path: '/detailsInfo',
      name: 'detailsInfo',
      component:  () => import("../views/index/detailsInfo.vue"),
    },
    {
      path: '/editTb',
      name: 'editTb',
      component:  () => import("../views/index/editTb.vue"),
    },

    {
      path: '/privacy',
      name: 'privacy',
      component: privacy,
    },

    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement,
    },

    {
      path:'/userCenter',
      name:'userCenter',
      component:userCenter,
      children:[
          {
            path:'/userInfo',
            name:'userInfo',
            component:userInfo,
      },
        {
          path:'/contactPage',
          name:'contactPage',
          component:  () => import("../views/userCenter/details/contactPage.vue"),
        },
        {
          path:'/addContact',
          name:'addContact',
          component:  () => import("../views/userCenter/details/addContact.vue"),
        },
        {
          path:'/invoiceRecord',
          name:'invoiceRecord',
          component:  () => import("../views/userCenter/details/invoiceRecord.vue"),
        },
        {
          path:'/invoicePage',
          name:'invoicePage',
          component:  () => import("../views/userCenter/details/invoicePage.vue"),
        },
        {
          path: '/addInvoice',
          name: 'addInvoice',
          component:  () => import("../views/userCenter/details/addInvoice.vue"),
        },
        {
          path: '/changePwd',
          name: 'changePwd',
          component:  () => import("../views/userCenter/details/changePwd.vue"),
        },
        {
          path: '/editInfo',
          name: 'editInfo',
          component:  () => import("../views/userCenter/details/editInfo.vue"),
        },
        {
          path: '/userMsg',
          name: 'userMsg',
          component:  () => import("../views/userCenter/details/userMsg.vue"),
        },
        {
          path:'/suggestion',
          name:'suggestion',
          component:  () => import("../views/userCenter/details/suggestion.vue"),

        }
      ]
    }
  ]
})
